import {normalizeActionHandler} from './normalizeActionHandler';

// TODO: this format should be deprecated in paris
export function mergeActions(actionHandlers, actions, tagName) {
	for (const k in actions) {
		const {
			handlers = [],
			effect: actionEffect,
			args: actionArgs,
			interceptors: actionInterceptors,
			private: isPrivate
		} = actions[k];
		const {length: handlersCount} = handlers;

		actionHandlers[k] = actionHandlers[k] || []; // eslint-disable-line no-param-reassign
		for (let i = 0; i < handlersCount; i++) {
			const handler = handlers[i];
			const {effect} = handler;
			const {fn, args = []} = effect || handler;
			if (typeof fn === 'function') {
				const {interceptors} = handler;
				actionHandlers[k].push(
					normalizeActionHandler({effect: fn, args, interceptors, private: isPrivate}, tagName)
				);
			} else {
				actionHandlers[k].push(normalizeActionHandler({...handler, private: isPrivate}, tagName));
			}
		}

		if ((handlersCount === 0 && isPrivate) || actionEffect || actionInterceptors) {
			actionHandlers[k].push(
				normalizeActionHandler(
					{
						effect: actionEffect || (() => ({})),
						interceptors: actionInterceptors,
						args: actionArgs,
						private: isPrivate
					},
					tagName
				)
			);
		}
	}

	return actionHandlers;
}
